module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alert":{"versionChange":"The server has been updated. Please refresh the page to avoid unpredictable behavior."}}}')
  delete Component.options._Ctor
}
